import { SegmentedControl } from '@/components/ui'
import {
  WorkspaceCompanyChips,
  type WorkspaceCompanyFilter,
} from '@/features/companies/components/WorkspaceCompanyFilter'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { EXPENSE_SCOPE_OPTIONS, type ExpenseScopeState } from './expenseScope'

/** Phones drop the icons, so all three labels fit across the screen. */
const TEXT_ONLY_OPTIONS = EXPENSE_SCOPE_OPTIONS.map((option) => ({
  value: option.value,
  label: option.label,
}))

/** All / Organization / Companies, with the company picker once companies are in view. */
export function ExpenseScopeFilter({
  scope,
  companies,
}: {
  scope: ExpenseScopeState
  companies: WorkspaceCompanyFilter
}): React.ReactElement {
  const wide = useMediaQuery('(min-width: 640px)')
  return (
    // Stacked on phones: side by side, the picker would stretch the full-width
    // switch past the screen edge.
    <div className="flex flex-col items-stretch gap-2 sm:flex-row sm:flex-wrap sm:items-center">
      <SegmentedControl
        ariaLabel="Which expenses"
        options={wide ? EXPENSE_SCOPE_OPTIONS : TEXT_ONLY_OPTIONS}
        value={scope.scope}
        onChange={scope.setScope}
        className="w-full sm:w-auto"
      />
      {scope.scope === 'company' && <WorkspaceCompanyChips filter={companies} />}
    </div>
  )
}
